export function writeCookie(name: string, value: string, days: number): void {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

export function getCookie(name: string): string | null {
  const cookieName = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(";");

  for (let i = 0; i < cookieArray.length; i++) {
    const cookie = cookieArray[i].trim();
    if (cookie.startsWith(cookieName)) {
      return cookie.substring(cookieName.length);
    }
  }

  return null;
}

export function deleteCookie(name: string): void {
  document.cookie = name + "=; Max-Age=0; path=/ ";
}

export function getCampaignParamsFromCookie(): Record<string, string> | null {
  const cookieName = "campaignCookies";
  const cookieValue = getCookie(cookieName);
  if (!cookieValue) {
    return null;
  }

  try {
    const decodedQueryString = atob(cookieValue);
    const queryStringWithoutLeadingQuestion = decodedQueryString.startsWith("?")
      ? decodedQueryString.slice(1)
      : decodedQueryString;

    const params = new URLSearchParams(queryStringWithoutLeadingQuestion);
    const paramsObject: Record<string, string> = {};

    params.forEach((value, key) => {
      paramsObject[key] = value;
    });

    return paramsObject;
  } catch (error) {
    console.error("Error parsing campaign cookie:", error);
    return null;
  }
}

export function snakeToCamelCase(obj: Record<string, any>): Record<string, any> {
  if (obj === null || obj === undefined) return obj;

  if (Array.isArray(obj)) {
    return obj.map((item) => snakeToCamelCase(item));
  }

  if (typeof obj !== "object") return obj;

  const camelCaseObj: Record<string, any> = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const camelKey = key.replace(/_([a-z])/g, (_, letter) =>
        letter.toUpperCase()
      );

      camelCaseObj[camelKey] = snakeToCamelCase(obj[key]);
    }
  }

  return camelCaseObj;
}

export function attachCampaignDataObject(input: Record<string, any>) {
  const campaignData = getCampaignParamsFromCookie();

  let requestData = input;
  if (campaignData) {
    requestData = {
      ...requestData,
      lastAttributionSource: snakeToCamelCase(campaignData),
    };
  }

  return requestData;
}

export function getSubmissionAttributionData(): Record<string, any> {
  const result: Record<string, any> = {};

  const visitorId = getCookie("ryb_visitor_id");
  if (visitorId) result.visitor_id = visitorId;

  const cookieValue = getCookie("campaignCookies");
  if (cookieValue) {
    try {
      const decoded = atob(cookieValue);
      const params = new URLSearchParams(
        decoded.startsWith("?") ? decoded.slice(1) : decoded
      );

      ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"]
        .forEach((key) => {
          const val = params.get(key);
          if (val) result[key] = val;
        });
    } catch {
      // Ignore malformed attribution cookies.
    }
  }

  try {
    const history = JSON.parse(
      localStorage.getItem("ryb_attribution_history") || "[]"
    );
    if (history.length > 0) {
      result.attribution_data = history;
    }
  } catch {
    // Ignore malformed localStorage attribution history.
  }

  return result;
}
